module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-t-mobile-intro-card1.2@2x.f53db51b.jpg";